<template>
  <div class="material-container">
    <Tabs :value="appName" @on-click="currentTabChanged">
      <TabPane label="启明瞳服务号" name="qmtfwh">
        <Card v-if="appName === 'qmtfwh'">
          <Tables ref="tables"
                  searchable
                  editable
                  border
                  :appName="appName"
                  :currPage="currPage"
                  :pageSize="pageSize"
                  :pageTotal="pageTotal"
                  v-model="tableData"
                  :columns="columns"
                  :loading="loading1"
                  :albumList="albumList"
                  :height="600"
          ></Tables>
        </Card>
      </TabPane>
      <TabPane label="无障碍科技" name="ACCESSIBILITY_TECHNOLOGY">
        <Card v-if="appName === 'ACCESSIBILITY_TECHNOLOGY'">
          <Tables ref="tables"
                  searchable
                  editable
                  border
                  :appName="appName"
                  :currPage="currPage"
                  :pageSize="pageSize"
                  :pageTotal="pageTotal"
                  v-model="tableData"
                  :columns="columns"
                  :loading="loading1"
                  :albumList="albumList"
                  :height="600"
          ></Tables>
        </Card>
      </TabPane>
      <TabPane label="我能帮帮忙服务号" name="I_Can_Help">
        <Card v-if="appName === 'I_Can_Help'">
          <Tables ref="tables"
                  searchable
                  editable
                  border
                  :appName="appName"
                  :currPage="currPage"
                  :pageSize="pageSize"
                  :pageTotal="pageTotal"
                  v-model="tableData"
                  :columns="columns"
                  :loading="loading1"
                  :albumList="albumList"
                  :height="600"
          ></Tables>
        </Card>
      </TabPane>
    </Tabs>
<!--    <Button style="margin: 10px 0;" type="primary" @click="exportExcel">导出为Csv文件</Button>-->
  </div>
</template>

<script>
    import Tables from "../tables/tables";
    import {format2Sec} from "../../utils/format";
    export default {
      name: "weChatMaterial",
      components: {Tables},
      data () {
        return {
          loading1: true,
          columns: [
            {
              title: '选择',
              type: 'selection',
              width: 60,
              align: 'center'
            },
            {
              title: '图片',
              width: 100,
              key: 'title-image',
              sortable: true,
              align: 'center',
              render: (h, params) => {
                return h('Tooltip', {
                  props: {
                    content: '点击访问原文链接',
                    placement: 'top'
                  }
                }, [h('a', {
                  attrs: {
                    href: params.row.url,
                    target: '_blank'
                  }
                }, [h('img', {
                  attrs: {
                    src: params.row.thumbUrl,
                  },
                  style: {
                    width: '50px',
                    height: '50px'
                  }
                })])]);
              }
            },
            {
              title: '标题',
              key: 'title',
              editable: true,
              minWidth: 500,
              align: 'center'
            },
            {
              title: '作者',
              key: 'author',
              editable: true,
              width: 200,
              sortable: true,
              align: 'center'
            },
            {
              title: '更新时间',
              key: 'time',
              width: 260,
              sortable: true,
              /*editable: true,*/
              align: 'center',
              render: (h, params) => {
                return h('span', this.tableData[params.index].time);
              }
            },
            {
              title: '专辑',
              key: 'album',
              width: 200,
              sortable: true,
              editable: true,
              align: 'center'
            },
            {
              title: '操作',
              key: 'handle',
              align: 'center',
              width: 300,
              fixed: 'right'
            }
          ],
          appName: 'qmtfwh',
          tableData: [],
          albumList: [],
          currPage: 1,
          pageSize: 10,
          pageTotal: 0,
          pageResultVo: {}
        };
      },
      computed: {

      },
      methods: {
        currentTabChanged(name){
            this.tableData = [];
            this.loading1 = true;
            this.appName = name;
            setTimeout(
              () => {
                this.getTableData();
              }, 1500);
        },
        getAlbumName (id) {
          let name;
          for (let i = 0; i < this.albumList.length; i++){
            if (id === this.albumList[i].id){
              name = this.albumList[i].name;
              break;
            }else{
              name = '请添加所属专辑';
            }
          }
          return name;
        },
        getTableData () {
          this.pageResultVo.content = {appName : this.appName};
          this.pageResultVo.currPage = this.currPage;
          this.pageResultVo.pageSize = this.pageSize;
          this.$http.post('/zm/backManage/queryBackMaterialListByPage', this.pageResultVo).then(res => {
              this.currPage = res.data.currPage;
              this.pageSize = res.data.pageSize;
              this.pageTotal = res.data.pageTotal;
              this.loading1 = false;
              let tempData = res.data.content;
              tempData.map((item, index) => {
                let res1 = item;
                if (res1.updateTime){
                  res1.time = format2Sec(res1.updateTime);
                }
                res1.album = this.getAlbumName(res1.albumId);
                return res1;
              });
              this.tableData = tempData;
            },
            err => {
              this.$Message.error("请求失败：" + err.message);
            });
        },
        /*exportExcel () {
          this.$refs.tables.exportCsv({
            filename: `table-${(new Date()).valueOf()}.csv`
          });
        }*/
      },

      created () {
        this.$http.post("/zm/backManage/queryAlbumList", {}).then(
          res => {
            this.albumList = res.data.content;
            this.getTableData();
          },
          err => {
            this.$Message.error("请求失败：" + err.message);
          }
        );
      },

      mounted () {

      }
    };
</script>

<style scoped>
  .materialForm{
    margin: 50px;
  }
</style>



// WEBPACK FOOTER //
// weChatMaterial.vue?57ec6bcf